import {DefaultService} from "./DefaultService";

class BannerService extends DefaultService {
    getBanner(location, params){
        return this.get('/banners/' + location, params).then(res => res.result)
    }
}

export default BannerService;